import React, { useState, useEffect } from 'react';
import { 
  FaTaxi, 
  FaCar, 
  FaTrain, 
  FaPlane, 
  FaCalendarDay, 
  FaStar,
  FaChevronRight,
  FaChevronDown,
  FaUserFriends,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaClock,
  FaShieldAlt,
  FaPhoneAlt,
  FaWhatsapp
} from 'react-icons/fa';
import { GiSteeringWheel } from 'react-icons/gi';
import '../style.css';

const BookCruise = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  const [activeImage, setActiveImage] = useState(0);

  const carImages = [
   
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImage((prev) => (prev + 1) % carImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const taxiServices = [
    {
      id: 1,
      name: "26 Seater Tempo Traveller",
      icon: <FaUserFriends />,
      stationPickup: 2600,
      airportPickup: 3200,
      ratePerKm: 32,
      fullDayRate: "Rs.32/Km 250 KM minimum",
      details: "Perfect for large groups, family tours, and corporate outings. Air-conditioned comfort with spacious seating.",
      features: ["AC", "Spacious", "Group Travel", "Luggage Space"],
      image: "https://3.imimg.com/data3/GK/GW/MY-12810608/51_tempo-traveller_12str-250x250.jpg",
      color: "#8B4513"
    },
    {
      id: 2,
      name: "Force Urbania",
      icon: <GiSteeringWheel />,
      stationPickup: 2800,
      airportPickup: 3500,
      ratePerKm: 35,
      fullDayRate: "Rs.35/Km 250 km",
      details: "Luxury travel with premium seating, entertainment system, and VIP experience.",
      features: ["Luxury", "Entertainment", "VIP", "Comfort"],
      image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w-800&auto=format&fit=crop",
      color: "#D4AF37"
    },
    {
      id: 3,
      name: "Tempo Traveller 16 Seater",
      icon: <FaUserFriends />,
      stationPickup: 2000,
      airportPickup: 2500,
      ratePerKm: 24,
      fullDayRate: "Rs.24/Km 250 km",
      details: "Mid-size group transport solution with comfortable seating and reliable service.",
      features: ["Mid-size", "Comfort", "Reliable", "Group"],
      image: "https://th.bing.com/th/id/OIP.z9mXuBmxPgpOACrlafSCrAHaFP?w=234&h=180&c=7&r=0&o=7&pid=1.7&rm=3",
      color: "#8B4513"
    },
    {
      id: 4,
      name: "Innova Crysta",
      icon: <FaCar />,
      stationPickup: 1000,
      airportPickup: 1800,
      ratePerKm: 18,
      fullDayRate: "Rs.18/Km 250 km",
      details: "Premium SUV with luxury interiors, perfect for family trips and business travel.",
      features: ["Premium", "SUV", "Luxury", "Family"],
      image: "https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=800&auto=format&fit=crop",
      color: "#D4AF37"
    },
    {
      id: 5,
      name: "Maruti Artiga",
      icon: <FaCar />,
      stationPickup: 900,
      airportPickup: 1400,
      ratePerKm: 14,
      fullDayRate: "Rs.14/Km 250 km",
      details: "Economical MPV with excellent fuel efficiency, ideal for family trips.",
      features: ["Economical", "MPV", "Fuel Efficient", "Family"],
      image: "https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=800&auto=format&fit=crop",
      color: "#8B4513"
    },
    {
      id: 6,
      name: "Swift Dzire",
      icon: <FaCar />,
      stationPickup: 700,
      airportPickup: 1000,
      ratePerKm: 12,
      fullDayRate: "Rs.12/km 250 KM minimum",
      details: "Compact sedan perfect for city travel, airport transfers, and business meetings.",
      features: ["Compact", "Sedan", "City", "Economical"],
      image: "https://th.bing.com/th/id/OIP.PpDb35ARdIRcmRc_5vHHvQHaFj?w=308&h=185&c=7&r=0&o=7&pid=1.7&rm=3",
      color: "#D4AF37"
    }
  ];

  const clientReviews = [
    {
      id: 1,
      name: "Mani Dubey",
      rating: 5,
      comment: "Shree Balaji Travel ki service bhut hi perfect hai. On-call support behtareen tha — especially Prama ji ka special thanks, unhone har step par bahut help ki. Highly recommended!",
      date: "Recently",
      avatar: "MD"
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      rating: 5,
      comment: "Excellent service! Clean cars, punctual drivers, and very reasonable rates. Will definitely use again!",
      date: "2 days ago",
      avatar: "RK"
    },
    {
      id: 3,
      name: "Priya Sharma",
      rating: 4,
      comment: "Very comfortable journey from airport to hotel. Driver was professional and car was spotless.",
      date: "1 week ago",
      avatar: "PS"
    }
  ];

  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div className="taxi-premium-container">
      {/* Hero Section with Image Slider */}
      \

      {/* Services Section */}
      <div className="services-section">
        <div className="section-header">
          <h2>Our Premium <span className="highlight">Fleet</span></h2>
          <p>Choose from our luxury fleet for your travel needs</p>
        </div>

        <div className="services-grid-premium">
          {taxiServices.map((service) => (
            <div 
              key={service.id} 
              className={`service-card-premium ${expandedCard === service.id ? 'expanded' : ''}`}
              style={{ '--accent-color': service.color }}
              onClick={() => toggleCard(service.id)}
            >
              <div className="card-image" style={{ backgroundImage: `url(${service.image})` }}>
                <div className="image-overlay"></div>
                <div className="service-icon-premium" style={{ backgroundColor: service.color }}>
                  {service.icon}
                </div>
              </div>
              
              <div className="card-content">
                <div className="card-header-premium">
                  <h3>{service.name}</h3>
                  <button className="read-more-btn-premium">
                    {expandedCard === service.id ? <FaChevronDown /> : <FaChevronRight />}
                    Details
                  </button>
                </div>


                {expandedCard === service.id && (
                  <div className="expanded-content">
                    <div className="features-list">
                      {service.features.map((feature, index) => (
                        <span key={index} className="feature-tag">{feature}</span>
                      ))}
                    </div>
                    <p className="service-description-premium">{service.details}</p>
                    <div className="action-buttons">
                      <button className="book-now-btn-premium">
                        <FaCar /> Book Now
                      </button>
                      <button className="call-btn">
                        <FaPhoneAlt /> Call Now
                      </button>
                      <button className="whatsapp-btn">
                        <FaWhatsapp /> WhatsApp
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Ready for Your <span className="highlight">Luxury Ride?</span></h2>
          <p>Book your premium taxi service now and experience comfort like never before</p>
          <button className="cta-button">
            <FaPhoneAlt /> Call Now: +91 9415799879
          </button>
        </div>
      </div>

      {/* Reviews Section */}
      <div className="reviews-section-premium">
        <div className="section-header">
          <h2>Client <span className="highlight">Reviews</span></h2>
          <p>What our valued customers say about us</p>
        </div>

        <div className="reviews-grid">
          {clientReviews.map((review) => (
            <div key={review.id} className="review-card-premium">
              <div className="review-header-premium">
                <div className="reviewer-avatar-premium">
                  {review.avatar}
                </div>
                <div className="reviewer-info">
                  <h4>{review.name}</h4>
                  <div className="review-stars-premium">
                    {[...Array(review.rating)].map((_, i) => (
                      <FaStar key={i} className="star-icon-premium" />
                    ))}
                  </div>
                </div>
                <span className="review-date">{review.date}</span>
              </div>
              <p className="review-comment-premium">"{review.comment}"</p>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default BookCruise;